module.exports = __webpack_public_path__ + "static/media/cdb8.48eb2698.png";